import synclounge from './synclounge';
import settings from './settings';
import plex from './plex';
import plexclients from './plexclients';
import plexservers from './plexservers';
import slplayer from './slplayer';

export default {
  synclounge,
  plex,
  plexclients,
  plexservers,
  settings,
  slplayer,
};
